import React from 'react';

interface BusinessIconProps {
  width?: number;
  height?: number;
  color?: string;
  strokeColor?: string;
  className?: string;
}

const BusinessIcon: React.FC<BusinessIconProps> = ({
  width = 19,
  height = 19,
  color = '#27788C',
  strokeColor = 'black',
  className,
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 19 19"
      fill="none"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.5 4.5V0.5H18.5V18.5H0.5V8.5H9.5V4.5ZM2.5 16.5H4.5V14.5H2.5V16.5ZM2.5 12.5H4.5V10.5H2.5V12.5ZM7.5 16.5H9.5V14.5H7.5V16.5ZM7.5 12.5H9.5V10.5H7.5V12.5ZM11.5 16.5H16.5V14.5H11.5V16.5ZM11.5 12.5H16.5V10.5H11.5V12.5ZM11.5 8.5H16.5V6.5H11.5V8.5ZM11.5 4.5H16.5V2.5H11.5V4.5Z"
        fill={color}
        stroke={strokeColor}
      />
    </svg>
  );
};

export default BusinessIcon;
